import React from 'react';
import styles from './creditSkeletons.module.css';

const Bar = ({ className }) => <span className={`${styles.bar} ${className}`} />;

// role=status + aria-label: скринридер объявит загрузку, а не прочтёт набор пустых полос
const Skeleton = ({ label, children, ...props }) => (
  <div role="status" aria-busy="true" aria-label={label} {...props}>
    {children}
  </div>
);

/** Вместо блока «Данные заявки»: те же восемь полей «подпись + значение». */
export const ApplicationSkeleton = () => (
  <Skeleton label="Загружаем данные заявки" className={styles.fields}>
    {Array.from({ length: 8 }, (_, i) => (
      <div key={i}>
        <Bar className={styles.label} />
        <Bar className={styles.value} />
      </div>
    ))}
  </Skeleton>
);

/** Вместо блока «Банки»: карточка банка — логотип, название, статус, показатели, кнопка. */
export const BankOffersSkeleton = () => (
  <Skeleton label="Загружаем ответы банков" className={styles.bank}>
    <div className={styles.bankHeader}>
      <Bar className={styles.logo} />
      <Bar className={styles.name} />
      <Bar className={styles.status} />
    </div>
    <div className={styles.bankInfo}>
      {Array.from({ length: 4 }, (_, i) => (
        <div key={i}>
          <Bar className={styles.label} />
          <Bar className={styles.value} />
        </div>
      ))}
    </div>
    <Bar className={styles.button} />
  </Skeleton>
);
